import * as React from 'react';
import PropTypes from "prop-types";
import Button from "../../components/Button";
import {Alert, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader, Progress} from "reactstrap";
import {get} from "lodash";
import {useTranslation} from "react-i18next";

const DisplayErrors = ({errors}) => {
  return <Alert color="warning">
    <ListGroup>
      {errors.map(error => {
        return <ListGroupItem className="p-2">{<div dangerouslySetInnerHTML={{__html: error}} />}</ListGroupItem>
      })}
    </ListGroup>
  </Alert>;
}

function RemoveModal(props) {
  const { t } = useTranslation('app_table')
  const [deletingEnds, setDeletingEnds] = React.useState(false);
  const [errors, setErrors] = React.useState([]);
  const [deleted, setDeleted] = React.useState(0);
  const [modalOpen, setModalOpen] = React.useState();
  const toggleModalOpen = () => setModalOpen(!modalOpen);
  const [deleting, setDeleting] = React.useState(false);

  React.useEffect(() => {
    if(!modalOpen){
      setDeletingEnds(false);
      setErrors([]);
      setDeleted(0);
    }
  }, [modalOpen]);

  const deleteSelected = async() => {
    setDeletingEnds(false);
    if(props.deleteFunc){
      setDeleting(true);
    }

    const del = key => {
      if(!props.selected[key]){
        setTimeout(() => {
          setDeletingEnds(true);
          setDeleting(false);
          if(errors.length === 0){
            setModalOpen(false);
          }
          props.onDeleted();
        }, props.deleteFunc ? 500 : 0)
        return;
      }

      if(props.deleteFunc){
        props.deleteFunc(get(props.selected[key], props.propertyDeleteIdPath))
        .then(() => {
          setDeleted(key+1);
          del(key+1);
        })
        .catch(res => {
          if(res.response.data.msg){
            errors.push(res.response.data.msg);
          }

          if(res.response.data['hydra:description']){
            errors.push(res.response.data['hydra:description']);
          }

          setDeleted(key+1);
          setErrors(errors);
          del(key+1);
        });
      }else{
        setDeleted(key+1);
        del(key+1);
      }
    };

    del(0);
  }

  return (
    <React.Fragment>
      <Button size={props.size} color="danger" onClick={toggleModalOpen} disabled={props.selected.length === 0}>
        <i className="fas fa-trash" />
        <span className="d-none d-sm-block d-md-none">{t('remove_modal.btn.delete_short')}</span>
        <span className="d-none d-md-block">{t('remove_modal.btn.delete_long')}</span>
        {props.selected.length > 0 && <span className="ml-2">({props.selected.length})</span>}
      </Button>
      {modalOpen && <Modal isOpen className="modal-danger" size="lg">
        <ModalHeader toggle={toggleModalOpen}>{t('remove_modal.title_text')}</ModalHeader>
        <hr className="my-0"/>
        <ModalBody>
          {(!deletingEnds && !deleting && deleted === 0) && <span>{t('remove_modal.body_text')}</span>}
          {deleting && <div className="d-flex flex-column mb-2">
            <Progress
              color="danger"
              value={deleted + 1}
              max={props.selected.length}
              children={<span>{Math.min(deleted + 1, props.selected.length)}/{props.selected.length}</span>}
            />
          </div>}
          {errors.length > 0 && <DisplayErrors errors={errors} />}
        </ModalBody>
        <ModalFooter>
          {deletingEnds && <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>{t('common:btn.close')}</Button>}

          {(!deletingEnds && !deleting) && <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>{t('common:btn.cancel')}</Button>}
          {!deletingEnds && <Button
            color="danger"
            loading={deleting}
            onClick={deleteSelected}
          >{t('remove_modal.btn.confirm')}</Button>}
        </ModalFooter>
      </Modal>}
    </React.Fragment>
  );
}

RemoveModal.defaultProps = {
  size: 'md',
};

RemoveModal.propTypes = {
  size: PropTypes.string,
  propertyDeleteIdPath: PropTypes.string.isRequired,
  deleteFunc: PropTypes.func,
  selected: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
  onDeleted: PropTypes.func.isRequired,
};

export default RemoveModal;